import React, { useEffect, useState } from "react";
import PageHeader from "../../../componentsII/PageHeader";
import CardsStatus from "../../../componentsII/CardStatusNGC";
import api from "../../../axios/api";
import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "../../../redux/slices/notificationSlice";
import locationimg from "../../../images/Location.jpg";
import Loader from "../../../componentsII/Loader";
import { Box, Modal } from "@mui/material";
import { X } from "lucide-react";
import PurchasedCoolingDetailModal from "../../../components/PurchasedCooling/PurchasedCoolingDetailModal";

const PurchasedCooling = () => {
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [locations, setLocations] = useState([]);

  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [detailModalData, setDetailModalData] = useState({});

  const { user } = useSelector((state) => state);
  const year = useSelector((state) => state.user.selectedYear);

  const dispatch = useDispatch();

  const fetchElectricityConsumption = async () => {
    setIsDataLoading(true);
    try {
      const response = await api.get(`/company/getPurchasedCooling?company_id=${user.user?.company?.id}&year_id=${year.id}`);
      if (response.data.locations) {
        setLocations(response.data.locations);
      } else {
        dispatch(
          showNotification({
            message: response.data.message,
            type: "error",
          })
        );
        console.log(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsDataLoading(false);
  };

  useEffect(() => {
    fetchElectricityConsumption();
  }, []);

  const locationsToInclude = locations.filter(location => location.cooling_consumption.cooling_consumption_id !== undefined);

  const locationsToExclude = locations.filter(location => location.cooling_consumption.cooling_consumption_id === undefined);

  return (
    <div>
      <PageHeader
        title="Purchased Cooling"
        text={["click into each location card in the left panel to add your cooling usage data ",
          "you'll need the method of cooling used and the amount consumed(e.g. 230 kWh) during your reporting period"]}
        buttonTitle=""
        handleClick={() => {}}
      >
        {isDataLoading ? (
          <div className="w-full h-[200px] flex justify-center items-center">
            <Loader />
          </div>
        ) : locations.length === 0 ? (
          <div className="text-center py-16 bg-gray-50 rounded-lg">
            <img
              src="/vectors/white isometric factory.jpg"
              alt="No Data"
              className="w-80 h-80 mx-auto text-gray-400 mb-4"
            />
            <h3 className="text-xl font-medium text-gray-600 mb-2">
              No Locations Found
            </h3>
            <p className="text-gray-500">
              Add your first Location to get started
            </p>
          </div>
        ) : (
          <CardsStatus
            img={locationimg}
            text1={
              <div className="flex items-center">
                <p className="bg-red-200 w-8 h-8 flex justify-center items-center rounded-full mr-4">
                  {locationsToExclude?.length}
                </p>
                Location(s) need to have data added
              </div>
            }
            text2={
              <div className="flex items-center">
                <p className="bg-green-200 w-8 h-8 flex justify-center items-center rounded-full mr-4">
                  {locationsToInclude?.length}
                </p>
                Done
              </div>
            }
            data1={locationsToExclude}
            data2={locationsToInclude}
            buttonTitle1="+ Add Data"
            buttonTitle2="Edit Data"
            buttonIClassname="bg-green-600 hover:bg-green-700 text-white border border-green-500 font-medium w-full text-center flex justify-center hover:-translate-y-0"
            buttonIIClassname="bg-gray-50 hover:bg-gray-100 text-gray-900 border border-gray-900 font-medium w-full text-center flex justify-center hover:-translate-y-0"
            buttonClick={(item, isAdd) => {
              setIsDetailModalOpen(true)
              setDetailModalData(item);
            }}
          />
        )}
        <Modal
          open={isDetailModalOpen}
          onClose={() => setIsDetailModalOpen(false)}
          aria-labelledby="add-location-modal-title"
          aria-describedby="add-location-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: "8px",
              display: "relative",
            }}
          >
            <button
              onClick={() => setIsDetailModalOpen(false)}
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
              aria-label="Close"
            >
              <X size={24} />
            </button>
            <PurchasedCoolingDetailModal
              detailModalData={detailModalData}
              handleCloseMainDetailModal={() => setIsDetailModalOpen(false)}
              refetch={fetchElectricityConsumption}
            />
          </Box>
        </Modal>
      </PageHeader>
    </div>
  );
};

export default PurchasedCooling;
